<template>
  <div>
    <v-dialog v-model="show" persistent max-width="70%">
      <v-card>
        <v-app-bar dark text color="secondary">
          <v-toolbar-title class="subheading">{{ page_title }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('global.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="coursetemplates"
            :items-per-page="coursetemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="show_select"
            v-model="selected"
            :must-sort="true"
          >
            <template v-slot:item.coursetypegroup_id="{ item }">
              {{ item.coursetypegroup.full_name }}
            </template>

            <template v-slot:item.coursetemplatetype_id="{ item }">
              {{ $dd_course_templates_type(item.coursetemplatetype_id) }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_course_templates_status(item.status) }}
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="pa-3">
          <p v-if="mode == 'coursetemplate-moduletemplate-edit'">{{ $t("coursetemplates.proceed_template_editing") }}</p>
          <v-spacer></v-spacer>

          <div v-if="mode == 'default'">
            <action-button type="cancel" @click="cancel" small />
            <action-button type="save" @click="submit" small />
          </div>

          <div v-if="mode == 'coursetemplate-moduletemplate-edit'">
            <action-button type="save" :text="$t('global.yes')" :icon="'fas fa-check'" @click="submit" small />
            <action-button type="cancel" :text="$t('global.no')" :icon="'fas fa-times'" @click="cancel" small />
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CourseTemplateListPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    show_select: {
      type: Boolean,
      default: true
    },
    ids: {
      type: Array
    },
    except_ids: {
      type: Array
    },
    moduletemplate_id: {
      type: Number
    },
    mode: {
      type: String,
      default: "default"
    },
    title: {
      type: String
    }
  },

  data() {
    return {
      page_title: "",
      url: "",
      selected: [],
      coursetemplates: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"],
        sortDesc: []
      },
      search_params: {
        not_in_ids: "",
        title: "",
        any: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("coursetemplates.name"), value: "name" },
          { text: this.$t("coursetypegroups.title"), value: "coursetypegroup_id" },
          { text: this.$t("coursetemplates.price"), value: "price" },
          { text: this.$t("coursetemplates.status"), value: "status" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.coursetemplates = []
          this.list()
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "coursetemplates"
    this.page_title = this.title || this.$t("coursetemplates.title")
  },

  methods: {
    list() {
      this.show_loading = true

      this.search_params.ids = this.ids ? this.ids.join(",") : null
      this.search_params.not_in_ids = this.except_ids ? this.except_ids.join(",") : null
      this.search_params.moduletemplate_id = this.moduletemplate_id ? this.moduletemplate_id : null

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.coursetemplates = res.data.data

        if (this.mode == "coursetemplate-moduletemplate-edit" && this.coursetemplates.length == 1) {
          this.submit()
          return
        }

        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    cancel() {
      this.$emit("callback_coursetemplistpopup_cancel")
    },

    submit() {
      this.$emit("callback_coursetemplistpopup_submit", this.selected)
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
